import { styled } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { Typography } from "@mui/material";
import { getBrandCustom } from "../../../../util/getCustomColor";

export const ProjectFieldContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "5px",
}));

export const ProjectLabel = styled(Typography)(() => ({
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 600,
}));

const styles = makeStyles(() => ({
  mainDiv: {
    padding: "32px",
  },
  uiTab: {
    height: "100% !important",
  },
  buttonLink: {
    marginLeft: "20px",
  },
  title: {
    color: getBrandCustom("primaryColor", "#38cfc4"),
    fontSize: "18px",
    fontFamily: "Inter",
    fontWeight: 600,
    lineHeight: "24px",
  },
  activeBadge: {
    background: `${getBrandCustom("primaryColor", "#38cfc4")} !important`,
    fontSize: "10px",
    fontWeight: 700,
    textTransform: "uppercase",
    padding: "6px 9px 4px",
  },
  inactiveBadge: {
    backgroundColor: "#CF4842 !important",
    fontSize: "10px",
    fontWeight: 700,
    textTransform: "uppercase",
    padding: "6px 9px 4px",
  },
}));

export default styles;
